import React, { useContext, useEffect, useState } from "react";
import Message from "../../assets/message.png";
import Dev from "../../assets/dev.png";
import Lock from "../../assets/lock.png";
import Scientist from "../../assets/scientist.png";
import Line from "../../assets/line.png";
import { Alert, Button, TextField } from "@mui/material";
import {
  Apple,
  FacebookOutlined,
  Google,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { inputs } from "../../datas/Registry";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { gapi } from "gapi-script";
import SocialButton from "./SocialButton.js";
import { Responsive } from "../../context/landing/Responsive";
function Middle({ place }) {
  const navigate = useNavigate();
  const [width, setWidth] = useState(false);
  const [there, setThere] = useState(false);
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId:
          "215666452181-gjr76r5um9ov7b75f3cjnvankjsm09gv.apps.googleusercontent.com",
        scope: "email",
      });
    }
    gapi.load("client:auth2", start);
  }, []);
  const [values, setValues] = useState({
    email: "",
    password: "",
    fullname: "",
  });
  useEffect(() => {
    window.innerWidth <= 1161 ? setWidth(true) : setWidth(false);
  }, [width]);
  useEffect(() => {
    window.addEventListener("resize", () => {
      window.innerWidth <= 1161 ? setWidth(true) : setWidth(false);
    });
  });
  const [err, setErr] = useState(null);
  const handleSocialLoginFailure = (err) => {
    console.error(err);
  };
  const submit = async (e) => {
    e && e.preventDefault();
    try {
      const res = await axios.post(`/api/auth/${place}`, values);
      console.log(res.data);
    } catch (error) {
      setThere(!there);
      setErr(error.response.data);
    }
  };
  const handleSocialLoginSuccess = async (res, splace) => {
    var { idToken } = res._token;
    try {
      const response = await axios.post(
        `api/auth/${splace}`,
        idToken === undefined
          ? {
              id: res._profile.id,
              email: res._profile.email,
              password: res._profile.id,
              profile: res._profile.profilePicURL,
              fullname: res._profile.name,
              login: place === "login",
            }
          : { login: place === "login" },
        {
          headers: idToken ? { Authorization: "Bearer " + idToken } : {},
        }
      );
      localStorage.setItem("token", response.data);
      navigate("/");
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const [password, setPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState(true);
  const changeVisibility = (type) => {
    if (type) {
      setPassword(!password);
    } else {
      setConfirmPassword(!confirmPassword);
    }
  };
  return (
    <div className="flex justify-center items-center w-[70%]">
      <>
        {!width && (
          <div>
            {place !== "login" ? (
              <img
                src={Dev}
                alt="dev"
                className="min-w-[20rem] max-w-[25rem]"
              />
            ) : (
              <div className="flex flex-col items-end">
                <img
                  src={Line}
                  alt="line"
                  className="relative -right-24 -top-5 min-w-[20rem] max-w-[25rem]"
                />
                <img
                  src={Lock}
                  alt="lock"
                  className="min-w-[20rem] max-w-[25rem]"
                />
              </div>
            )}
          </div>
        )}
        <div
          style={{ boxShadow: "0px 4px 20px rgba(21, 42, 116, 0.25)" }}
          className="bg-white text-[#152A74] gap-5 rounded-[50px] flex items-center justify-center max-w-full min-w-[30rem] px-10 py-10 flex-col"
        >
          <h1 className="font-[800] text-4xl">
            {place === "signup" ? "Sign Up" : "Log in"}
          </h1>
          <div className="max-w-[24rem] my-2 font-medium text-center">
            {place === "login"
              ? "Hey there , log in to enjoy Levitra's daily services"
              : "Hey there ,  enter your details to get an account in Levitra."}
          </div>
          <form
            onSubmit={submit}
            className="flex items-center justify-center gap-7 flex-col"
          >
            {err && (
              <Alert style={{ width: "23rem" }} severity="error">
                {err}
              </Alert>
            )}
            {inputs
              .slice(!!(place === "login"), 4 - !!(place === "login"))
              .map((input, index) => (
                <div className="relative" key={index}>
                  <TextField
                    type={
                      input.includes("Password")
                        ? input === "Password"
                          ? password
                            ? "password"
                            : "text"
                          : confirmPassword
                          ? "password"
                          : "text"
                        : "text"
                    }
                    className="w-[23rem]"
                    key={index}
                    variant="outlined"
                    onChange={(e) =>
                      setValues({
                        ...values,
                        [input.toLocaleLowerCase()]: e.target.value,
                      })
                    }
                    label={input}
                  />
                  {input.includes("Password") && (
                    <div
                      onClick={() => changeVisibility(input === "Password")}
                      className="absolute top-3 right-3 cursor-pointer bg-white"
                    >
                      {input === "Password" ? (
                        password ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )
                      ) : input === "Confirm Password" && confirmPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </div>
                  )}
                </div>
              ))}
            <Button
              type="submit"
              variant="contained"
              style={{
                background: "#152A74",
                borderRadius: "30px",
                fontSize: 18,
              }}
              className="w-[13rem]"
            >
              {place}
            </Button>
            <div className="flex w-full justify-center gap-2 items-center">
              <div className="border-b-[3px] h-2 w-[20%] border-black border-solid"></div>
              <div className="text-black font-medium">
                Or {place === "login" ? "Login" : "Sign Up"} with
              </div>
              <div className="border-b-[3px] h-2 border-black border-solid w-[20%]"></div>
            </div>
            <div className="flex gap-3 items-center">
              <SocialButton
                provider="google"
                appId="215666452181-gjr76r5um9ov7b75f3cjnvankjsm09gv.apps.googleusercontent.com"
                onLoginSuccess={(res) =>
                  handleSocialLoginSuccess(res, "google")
                }
                onLoginFailure={handleSocialLoginFailure}
                scope="https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.gender.read https://www.googleapis.com/auth/userinfo.profile"
              >
                <Google />
                <span>Google</span>
              </SocialButton>
              <Button
                variant="outlined"
                style={{
                  color: "#152A74",
                  border: "2px solid #152A74",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "5px",
                }}
              >
                <Apple />
                <span>Apple</span>
              </Button>
              <SocialButton
                provider="facebook"
                appId="1212809229472284"
                onLoginSuccess={(res) =>
                  handleSocialLoginSuccess(res, "facebook")
                }
                onLoginFailure={handleSocialLoginFailure}
              >
                <FacebookOutlined />
                <span>Facebook</span>
              </SocialButton>
            </div>
            <div className="mb-7">
              {place === "signup" ? (
                <div>
                  Already have an account{" "}
                  <Link to="/registry/login" className="font-bold text-xl">
                    login
                  </Link>
                </div>
              ) : (
                <div>
                  Don't have an account{" "}
                  <Link to="/registry/signup" className="font-bold text-xl">
                    signup
                  </Link>
                </div>
              )}
            </div>
          </form>
        </div>
        {!width && (
          <div className="flex flex-col relative -left-7 items-end gap-5">
            <img
              src={Message}
              alt="message"
              className="min-w-[20rem] max-w-[25rem]"
            />
            <img
              src={Scientist}
              alt="scientist"
              className="min-w-[20rem] max-w-[25rem]"
            />
          </div>
        )}
      </>
    </div>
  );
}

export default Middle;
